import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavbarComponent from "./components/common/NavbarComponent";
import KaptonList from "./components/KaptonList";
import Home from "./components/Home";
import MaterialList from "./components/MaterialList";
import TapeList from "./components/TapeList";
import UserList from "./components/UserList";
import BaseplateList from "./components/BaseplateList";
import ShipmentList from "./components/ShipmentList";
import InboundList from "./components/InboundList";
import RemoteList from "./components/RemoteList";
import SignUp from "./components/Login/Signup";
import Login from "./components/Login/Login";
import GlueList from "./components/GlueList";
import MetricContainer from "./components/metrics/Metrics";

import { DBProvider } from "./components/DatabaseContext";

function App() {
  return (
    <DBProvider>
      <Router basename={"/"}>
        <div>
          <ToastContainer
            style={{
              width: "auto",
              maxWidth: "2000px",
              wordBreak: "break-all",
            }}
          />
          <header className="fixed-top">
            <NavbarComponent />
          </header>
          <section>
            <div className="container-fluid p-3">
              <Routes>
                <Route path="/kapton-list" Component={KaptonList} />
                <Route path="/tape-list" Component={TapeList} />
                <Route path="/material-list" Component={MaterialList} />
                <Route path="/glue-list" Component={GlueList} />
                <Route path="/user-list" Component={UserList} />
                <Route path="/baseplate-list" Component={BaseplateList} />
                <Route path="/ship-list" Component={ShipmentList} />
                <Route path="/inbound-list" Component={InboundList} />
                <Route path="/remote-list" Component={RemoteList} />
                <Route path="/metrics" Component={MetricContainer} />
                <Route path="/signup" Component={SignUp} />
                <Route path="/login" Component={Login} />
                <Route exact path="/" Component={() => <Home />} />
              </Routes>
            </div>
          </section>
        </div>
      </Router>
    </DBProvider>
  );
}

export default App;
